import { useEffect, useState } from "react";
import apiClient from "../client/ApiGetClient";
import { apiConfig } from "../authConfig";
import { useMsal } from "@azure/msal-react";

export function usePost<T, R>(
  url: string,
  method: string,
  requestBody?: Object | FormData | string
) {
  const [isProgressVar, setProgressVar] = useState(false);
  const [errorMsg, setErrorMsg] = useState<Error | null>(null);
  const { instance, accounts } = useMsal();

  const postByObject = async (formData: R): Promise<T | null> => {
    try {
      setProgressVar(true);

      const data = await apiClient.sendRequest(
        url,
        method,
        formData as FormData
      );


      return data as T;
    } catch (error: any) {
      setErrorMsg(error.message);
      return null;
    } finally {
      setProgressVar(false);
    }
  };

  return { isProgressVar, errorMsg, postByObject };
}

export default usePost;
